import {Component, OnInit} from '@angular/core';
import {getCurrentMoonPhase, padNumber} from '../../utility';

@Component({
  selector: 'longmoon-moon',
  templateUrl: './moon.component.html',
  styleUrls: ['./moon.component.scss']
})
export class MoonComponent implements OnInit {
  moonPhase: number;
  moonPhaseUrl: string;

  constructor() {
    this.moonPhase = getCurrentMoonPhase();
    this.moonPhaseUrl = `../../../assets/img/starry-night/twilight-moon-phases/moon-phase-${padNumber(this.moonPhase)}.png`;
  }

  ngOnInit(): void {
  }
}
